import type { ReactNode } from 'react';

export const symbol_speed_0_7x: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m689-434-77 139q-4 7-10.5 11t-14.5 4q-17 0-25-14t0-28l91-164-85-152q-8-14-.5-28t24.5-14q8 0 14.5 4t10.5 11l72 128 71-128q4-7 10.5-11t14.5-4q17 0 25 14t0 28l-85 152 92 165q8 14 0 27.5T792-280q-8 0-14-3.5T768-294l-79-140ZM341-278q-14 0-23-11t-5-25l82-309H255q-13 0-21.5-8.5T225-653q0-13 8.5-21.5T255-683h140q24 0 42 16t18 40q0 3-2 13l-84 315q-2 10-10 15.5t-18 5.5Zm-172.5-7.5Q160-294 160-307t8.5-21.5Q177-337 190-337t21.5 8.5Q220-320 220-307t-8.5 21.5Q203-277 190-277t-21.5-8.5Z"
		/>
	</svg>
);
